import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(weekday);

const periods = ["day", "week", "month", "year"];

export const generateItems = (data, totalDays = 0) => {
  let remaining = data.batches;
  let startDate = dayjs(data.repeatStartDate);

  // First batch: starts at repeatStartDate, ends after totalDays business days
  let result = onUpdateDateHelper(
    startDate.format("MM/DD/YYYY"),
    true,
    totalDays,
  );
  remaining -= 1;

  const getRepeatWeekdays = (currentStartDate) => {
    let currentDate = dayjs(currentStartDate);
    for (const day of data.repeatWeekdays) {
      if (remaining <= 0) break;

      const newDate = currentDate.weekday(day).format("MM/DD/YYYY");
      result = onUpdateDateHelper(newDate, true, totalDays);
      remaining -= 1;
    }
  };

  while (remaining > 0) {
    if (data.repeatOption === 4) {
      getRepeatWeekdays(startDate);
      startDate = startDate
        .startOf("week")
        .add(data.repeatEveryIteration, periods[data.repeatEvery]);
    } else {
      startDate = startDate.add(1, periods[data.repeatOption - 1]);

      const newDate = startDate.format("MM/DD/YYYY");
      result = onUpdateDateHelper(newDate, true, totalDays);
      remaining -= 1;
    }
  }

  return result;
};

const onUpdateDateHelper = (value, isStart = false, daysToAdd = 0) => {
  let currentDate = new Date(value);

  const startAdd = isStart ? 1 : -1;
  let inDays = daysToAdd * startAdd;
  let it = Math.abs(inDays);

  while (it >= 0) {
    let date = new Date(currentDate.setDate(currentDate.getDate() + startAdd));
    while (date.getDay() % 6 === 0) {
      currentDate.setDate(currentDate.getDate() + startAdd);
      date = new Date(currentDate);
    }

    currentDate = new Date(date);
    it--;
  }

  const second = dayjs(currentDate).format("MM/DD/YYYY");

  const data = {
    startDate: isStart ? value : second,
    dueDate: isStart ? second : value,
  };

  return data;
};
